import { useScreenName } from './use-screen-name';
import { ScreenName } from '../utils';

/**
 * Returns true if the width of current screen name matches at least the width of the given screen name.
 * Supply an optional `ssrScreenName` for initial rendering.
 *
 * ```tsx
 * const isAtLeastMd = useScreenNameAtLeast('md');
 *
 * if (isAtLeastMd) {
 *   ...
 * }
 * ```
 */
export const useScreenNameAtLeast = (
  screenName?: ScreenName,
  ssrScreenName?: ScreenName,
): boolean => {
  const current = useScreenName(ssrScreenName);

  if (screenName === current) {
    return true;
  }

  const order: ScreenName[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

  const currIdx = order.findIndex(name => name === current);
  const desiredIdx = order.findIndex(name => name === screenName);

  return currIdx >= desiredIdx;
};
